import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/successfulAddRoleDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddRole_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddRole_action_icon' />
        <Typography className='SuccessfulAddRole_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfulAddRoleDialog = ({ openSuccessfulAddRole, setOpenSuccessfulAddRole, roleId, setOpenAddRole }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleOpenAdd = useCallback(() => {
        setOpenSuccessfulAddRole(false);
        setOpenAddRole(true);
    }, [setOpenAddRole, setOpenSuccessfulAddRole]);

    const handleNavigateToRolePage = useCallback(() => {
        navigate(`rôle_details/${roleId}`);
    }, [roleId, navigate]);

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddRole(false);
    }, [setOpenSuccessfulAddRole]);

    return (
        <Dialog open={openSuccessfulAddRole} onClose={handleClose} classes={{ paper: 'SuccessfulAddRole_dialog' }}>
            <IconButton onClick={handleClose} className='SuccessfulAddRole_icon_button'>
                <Iconify icon={"material-symbols:close"} className='SuccessfulAddRole_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddRole_dialog_content' >
                <Iconify icon={"lets-icons:check-ring-light"} className='SuccessfulAddRole_check_icon' />
                <Typography className='SuccessfulAddRole_message'>{t('AddMachine_validation_message')}</Typography>
                <Box className='SuccessfulAddRole_action_container'>
                    <ActionBox
                        icon={"pepicons-pop:file"}
                        text={t('Page de rôle')}
                        onClick={handleNavigateToRolePage}
                    />
                    <ActionBox
                        icon={"material-symbols-light:cards-outline"}
                        text={t('List des rôles')}
                        onClick={handleClose}
                    />
                    <ActionBox
                        icon={"material-symbols-light:add"}
                        text={t('addRoleDialogeTitle')}
                        onClick={handleOpenAdd}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};